import { render, staticRenderFns } from "./favorite-page.vue?vue&type=template&id=1983b270&scoped=true&"
import script from "./favorite-page.vue?vue&type=script&lang=ts&"
export * from "./favorite-page.vue?vue&type=script&lang=ts&"
import style0 from "./favorite-page.vue?vue&type=style&index=0&id=1983b270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983b270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
